<template>
  <div>
    <vue-headful :title="pageTitle"/>
    <v-form ref="form" lazy-validation>
      <v-layout>
        <h1><span>{{title}}</span></h1>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="mx-1" dark @click="save">Сохранить</v-btn>
        <v-btn color="primary" class="mx-1" dark @click="clear">Очистить</v-btn>
        <v-btn color="primary" class="ml-1 mr-0" dark @click="goBack">Вернуться</v-btn>
      </v-layout>

      <v-alert :value="alert" type="success">Аттестуемый сохранен</v-alert>

      <v-card>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs4 pr-2>

              <v-autocomplete
                v-model="editedItem.group.id"
                :items="groups"
                item-value="id"
                item-text="name"
                search-input
                :disabled="editing || !!$route.query.group"
                label="Группа"
                persistent-hint
                :error-messages="groupErrors"
              />
            </v-flex>
            <v-flex xs4 pl-2>

              <v-text-field
                tabindex="1"
                label="УИН"
                v-model="editedItem.uin"
                :error-messages="uinErrors"
                required
              />

            </v-flex>
            <v-flex xs4 pl-2>

              <v-text-field
                tabindex="1"
                label="Пароль"
                v-model="editedItem.password"
                :error-messages="passwordErrors"
                required
              />

            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-form>
    <ErrorDialog :dialog="errorDialog"/>
  </div>
</template>

<script>
import SettingsService from '@/services/SettingsService'
import ObjectUtils from '@/utils/ObjectUtils'
import Dialog from '@/components/fragments/Dialog'
import {required} from 'vuelidate/lib/validators'
import StudentService from '@/services/StudentService'
import ErrorDialog from '@/components/fragments/ErrorDialog'
import GroupService from '@/services/GroupService'

export default {
  props: {
    student: Object,
    editing: false,
    group: String
  },
  components: {ErrorDialog, Dialog},
  data: () => ({
    alert: false,
    inReset: false,
    defaultItem: StudentService.getDefaultItem(),
    groups: [],
    editedItem: {},
    errorDialog: {
      status: false,
      errors: [],
      title: 'Ошибка при сохранении'
    },
    studentService: undefined,
    groupService: undefined
  }),
  computed: {
    title () {
      return this.$route.meta.title
    },
    pageTitle () {
      return SettingsService.pageTitle(this.title)
    },
    groupErrors () {
      const errors = []
      if (!this.$v.editedItem.group.id.$dirty) return errors
      !this.$v.editedItem.group.id.required && errors.push('Поле должно быть заполнено.')
      return errors
    },
    uinErrors () {
      const errors = []
      if (!this.$v.editedItem.uin.$dirty) return errors
      !this.$v.editedItem.uin.required && errors.push('Поле должно быть заполнено.')
      return errors
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.editedItem.password.$dirty) return errors
      !this.$v.editedItem.password.required && errors.push('Поле должно быть заполнено.')
      return errors
    }
  },
  methods: {
    save () {
      this.alert = false
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.studentService.saveItem(this.editedItem, this.editing, (data) => {
          if (data.status) {
            this.alert = true
            if (!this.editing) this.clear()
          } else {
            this.errorDialog.errors = data.errors
            this.errorDialog.status = true
          }
        })
      }
    },
    goBack () {
      this.$router.back()
    },
    clear () {
      this.$v.$reset()
      this.editedItem = ObjectUtils.jsonCopy(this.defaultItem)
      this.editedItem.group = this.groups[0]
    }
  },
  created () {
    this.studentService = new StudentService(this.$store)
    this.groupService = new GroupService(this.$store)
    this.editedItem = ObjectUtils.jsonCopy(this.defaultItem)
    if (!this.$route.query.group) {
      this.groupService.getList((data) => {
        data.list.forEach(item => {
          item.organization = null
        })
        this.groups = data.list
      }, {
        limit: 0
      })
    } else {
      this.groupService.getItem(this.$route.query.group, (data) => {
        data.item.organization = null
        this.groups = [data.item]
        this.editedItem.group = this.groups[0]
      })
    }
  },
  watch: {
    student (val) {
      this.editedItem = ObjectUtils.jsonCopy(val)
    },
    'errorDialog.status' (val) {
      if (!val) {
        this.errorDialog.errors = []
      }
    }
  },
  validations: {
    editedItem: {
      uin: {required},
      password: {required},
      group: {
        id: {required}
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/student/EditForm.vue